import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var trueFilter = function trueFilter() {
  return true;
};
export var Library = /*#__PURE__*/function () {
  function Library(components) {
    _classCallCheck(this, Library);
    this.components = components;
  }

  /**
   * Field groups are needed for PropsFactory to easily find fields for specified component
   * unique identifier is created by merging libraries and component aliases used as a key
   */
  _createClass(Library, [{
    key: "getFieldGroups",
    value: function getFieldGroups() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : trueFilter;
      return this.components.reduce(function (groups, component) {
        return _objectSpread(_objectSpread({}, groups), {}, _defineProperty({}, component.getId(), component.getFields(filter)));
      }, {});
    }
  }, {
    key: "getDataFieldGroups",
    value: function getDataFieldGroups() {
      return this.getFieldGroups(function (field) {
        return !field.isNodeField();
      });
    }
  }, {
    key: "getNodeFieldGroups",
    value: function getNodeFieldGroups() {
      return this.getFieldGroups(function (field) {
        return field.isNodeField();
      });
    }
  }]);
  return Library;
}();